// extracted by mini-css-extract-plugin
export default {"uploadDocs_container":"uploadDocs_uploadDocs_container__mueWC"};